import { ContentProgressStatus } from '../contentProgress';
import { InstanceLanguage } from '../../constants/languageSelector';

// Request payload of get learning module
export interface GetLearningModuleGETRequest {
  moduleId: string;
  clientId: string;
  selLocale?: string;
}

// Response payload of get learning module
export interface GetLearningModuleGETResponse {
  module: LearningModuleApiData;
}
export interface ListLearningModulesGETRequest {
  clientId: string;
  selLocale?: string;
  queryPattern: {
    queryType: LearningModuleQueryType
    subtopicQuery?: {
      subtopicId: string
    }
    tagsQuery?: {
      tagIds: string[]
    }
  }
}

// Response payload of list learning modules
export interface ListLearningModulesGETResponse {
  modules: LearningModuleApiData[];
}

// Query types for learning modules
export enum LearningModuleQueryType {
  SubTopic = 'SUB_TOPIC',
  Tags = 'TAGS',
}

// Module preview API data type
export interface ModulePreviewApiData {
  moduleId: string;
  title: string;
  description: string;
  type: string;
  thumbnailLink: string;
  moduleProgressStatus?: string;
}

// This defines structures of instance url map
// For pdf instance, it will only include PDF url link
// For video instance, it will have YOUTUBE link or MediaCentral link or both
export interface InstanceUrlMapApiData {
  PDF?: string,
  MEDIA_CENTRAL?: string,
  YOUTUBE?: string
}

// This defines structure of instance, instance is child of LearningModule
export interface InstanceApiData {
  instanceId: string,
  instanceLanguage: string,
  instanceType: string,
  instanceVersion: number,
  moduleId: string,
  universityId: string,
  pageSize?: number,
  duration?: number,
  urlMap: InstanceUrlMapApiData
}

// This defines structure of SubContent, which is optional in LearningModule
export interface SubContentApiData {
  link: string;
  title: string;
}

// This defines structure for a module
export interface LearningModuleApiData {
  ctaText?: string;
  ctaLink?: string;
  defaultLanguage: string;
  description: string;
  instanceMap: Partial<Record<InstanceLanguage, InstanceApiData>>
  locale: string;
  moduleId: string;
  moduleProgressStatus: ContentProgressStatus;
  subContentList?: SubContentApiData[];
  thumbnailLink: string;
  title: string;
}

// Module card data from ListModuleCards API (Poly-backed, single-locale instance data)
export interface ModuleCardApiData {
  moduleId: string;
  title: string;
  description: string;
  thumbnailLink: string;
  locale: string;
  defaultLanguage: string;
  instanceMap?: Partial<Record<InstanceLanguage, InstanceApiData>>;
  ctaText?: string;
  ctaLink?: string;
  subContentList?: SubContentApiData[];
  lastUpdatedTimestamp?: number;
  availableLocalesList?: string[];
}

// Request payload for ListModuleCards API
export interface ListModuleCardsGETRequest {
  clientId: string;
  selLocale?: string;
  queryPattern: {
    queryType: LearningModuleQueryType;
    subtopicQuery?: {
      subtopicId: string;
    };
    tagsQuery?: {
      tagIds: string[];
    };
  };
}

// Response payload for ListModuleCards API
export interface ListModuleCardsGETResponse {
  cards: ModuleCardApiData[];
  nextToken?: string;
}
